import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  CardImg,
  Badge
} from "reactstrap";
import compoundImg from "assets/images/compound.png";
import cardImg from "assets/images/cardimg.png";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import DeveloperService from "services/Admin/DeveloperService"

const ProfilePage = (props) => {
  const id = props.match.params.id
  const [developer, setDeveloper] = useState(null);
  const developerService = new DeveloperService()

  useEffect(() => {
    developerService.find(id).then(res => {
      if (res && res.status === SuccessOk)
        setDeveloper({ ...res.data })
    })
  }, [])
  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Developer Profile</title>
        </MetaTags>
        <Container fluid>
          <h4>
            <button className="p-0 m-0 border-0 bg-light"
              onClick={() => {
                props.history.push(`${adminPrefix}/Admin-developer`)
              }}>
              <i className="fa fa-arrow-left text-primary me-2"></i>
            </button>
            Developer Profile
          </h4>
          <Card className="w-100 mt-4">
            <CardBody>
              <h5>Company Information</h5>
              <h5 className="pt-2 border-bottom pb-3">
                {developer ?.media ?.path ?
                  <img
                    src={developer ?.media ?.path}
                    alt={"developer image"} className="pe-2" width="42" height="42"
                  />
                  : null }
                <span className="font-size-14 text-muted">{developer ?.name ?.en}</span>
              </h5>
              <h5 className="pt-2 font-size-14">
                <span>Mobile Number</span>
                <span className="text-muted ps-2">{developer ?.phone}</span>
              </h5>
              <h5 className="pt-2 font-size-14">
                <span>Email Address</span>
                <span className="text-muted ps-2">{developer ?.email}</span>
              </h5>
              <h5 className="pt-2 font-size-14 linHeight">
                <span className="pb-2">Description</span>
                <span className="text-muted ps-2">{developer ?.description ?.en}</span>
              </h5>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <h5>Projects ({developer ?.compounds ?.length})</h5>
              <Row>
                {developer ?.compounds ?.map((compound, index) => {
                  return (
                    <Col xl={3} lg={4} sm={6} key={index} >
                      <Card className="my-2 cardShadow pb-2 comCard"  >
                        {compound ?.images ?.length > 0 ? compound ?.images ?.map((img, index) => {
                          if (index === 0) {
                            return <CardImg key={index} src={img.path} ></CardImg>

                          }
                        }) : <CardImg src={cardImg}  ></CardImg>
                     }
                        <CardBody className="pt-0 px-2 pb-0" style={{ minHeight: "190px" }}>
                          <h6 className="pt-2 txtHed font-size-16">{compound.name.en}</h6>
                          <p className="mb-2"><span className="font-size-14">Starting From</span> <span className="text-primary font-size-16">{toCurrency(compound.starting_from)}EGP</span></p>
                          <p className="font-size-14 mb-2">{compound.installment ? `Up to ${compound.installment} Years Installments` : "Cash"}</p>
                          {/* <Badge className="badgeProfile text-primary font-size-13 me-2">Appartment</Badge> */}
                          {compound ?.unit_types ?.map((unit, index) => {
                            return (
                              <Badge key={index} className="badgeProfile text-primary font-size-13 me-2 mt-1">{unit ?.name ?.en}</Badge>
                            )
                          })}
                        </CardBody>
                      </Card>
                    </Col>
                  )
                })}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

const toCurrency = (number) => {
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(number);
}
export default ProfilePage;
